export const COURIER_LOADING = 'COURIER_LOADING';
export const COURIER_FULFILLED = 'COURIER_FULFILLED';
export const COURIERS_FULFILLED = 'COURIERS_FULFILLED';
